module.exports = __webpack_public_path__ + "f48b2f5b682c81a49bd291186f7e6907.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/gef-icon-white.svg
// module id = 306
// module chunks = 0